export default __webpack_public_path__ + "static/media/rocket_anim_46.d5d75b90.png";